var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('div',{staticClass:"container home--header"},[(_vm.showHomeBtn)?_c('button',{staticClass:"home-btn",on:{"click":_vm.backBtnClickHandler}},[_c('div',[_c('b-icon',{attrs:{"pack":"fas","icon":"arrow-left","size":"is-small"}}),_c('p',[_vm._v(" Home ")])],1)]):_vm._e()]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }